import styled, { css } from 'styled-components';

interface ColProps {
  columnWidth?: number | string;
}

export interface ScheduleBlockProps {
  isStart?: boolean;
  isEnd?: boolean;
}

export const Root = styled.div`
  position: relative;
  padding-top: 60px;
`;

export const StickyHeader = styled.div`
  position: sticky;
  top: 60px;
  /* width: 500px; */
  max-width: var(--max-width);
  background-color: #181818;
  z-index: 28;
  padding: 20px 20px 0;
  /* transform: translate3d(-20px, 0, 0); */

  /* ${({ theme }) => theme.media.mobile} {
    width: 100vw;
  } */
`;

export const BlockBase = styled.div`
  width: 100%;
  height: 34px;
`;

export const ColTimeHolder = styled(BlockBase)`
  flex: 0 0 20px;
  width: 20px;
`;

export const Col = styled.div<ColProps>`
  width: 100%;

  ${({ columnWidth }) =>
    columnWidth &&
    css`
      flex: 0 0
        ${typeof columnWidth === 'number' ? `${columnWidth}px` : columnWidth};
    `}
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 50;
`;
